/**
 * FinanceLayout — Issue #134
 *
 * 财务模块侧边导航布局
 */

import { useLocation } from 'wouter';
import type { ReactNode } from 'react';

const NAV_ITEMS = [
  { path: '/finance/payment-records', label: '收款记录' },
  { path: '/finance/project-unlocks', label: '项目解锁' },
  { path: '/finance/invoices', label: '发票管理' },
  { path: '/finance/installments', label: '分期与逾期' },
  { path: '/finance/adjustments', label: '退款/补差价/转项目' },
  { path: '/finance/revenue-ledgers', label: '收益台账' },
  { path: '/finance/commission-ledgers', label: '提成台账' },
  { path: '/finance/templates', label: '财务模板' },
  { path: '/finance/counterparties', label: '对方与收款账户' },
  { path: '/finance/payment-applications', label: '付款申请' },
  { path: '/finance/employee-advances', label: '借支' },
  { path: '/finance/expense-reimbursements', label: '费用报销' },
  { path: '/finance/payroll', label: '工资发放' },
  // Issue #372 — multi-stage commission release / freeze / clawback /
  // payout candidates / wide-template export.
  { path: '/finance/commission/rules', label: '提成规则（多环节）' },
  { path: '/finance/commission/details', label: '提成明细（多环节）' },
  { path: '/finance/commission/payout-candidates', label: '月度发放候选' },
  { path: '/finance/commission/export', label: '提成宽表导出' },
  { path: '/finance/sales-report', label: '销售管理报表' },
  // Issue #402 — unified finance audit view.
  { path: '/finance/audit-view', label: '统一审计视图' },
];

export default function FinanceLayout({ children }: { children: ReactNode }) {
  const [location, navigate] = useLocation();

  return (
    <div className="flex min-h-full gap-6">
      {/* Side nav */}
      <nav className="w-44 shrink-0">
        <ul className="space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive = location.startsWith(item.path);
            return (
              <li key={item.path}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Main content */}
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
